import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';

@Component({
  selector: 'app-footer-style-two',
  templateUrl: './footer-style-two.component.html',
  styleUrls: ['./footer-style-two.component.scss']
})
export class FooterStyleTwoComponent implements OnInit {

  settings: any;
  working_hours: string = ''
  phone: string = ''
  email: string = ''
  address: string = ''

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadSetting()
  }

  loadSetting(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.settings = response.settings;
        this.working_hours = response.settings.working_hours;
        this.phone = response.settings.phone;
        this.email = response.settings.email;
        this.address = response.settings.address;
        localStorage.setItem('vendorPhone', this.phone)
      }, 
      error: (error: any) => {
        console.log(error);
      }
    });
  }

}
